'use client';

import { ConnectWithStrava } from '@/app/settings/VendorLogos';
import Loading from '@/app/components/Loading';
import {
  STRAVA_INTEGRATION_UNAVAILABLE,
  getAuthUrl,
} from '@/app/settings/Strava';
import { trpc } from '@/app/api/trpc/client';
import { useSearchParams } from 'next/navigation';

export const StravaConnectCard = () => {
  const { data: connected } = trpc.strava.connected.useQuery();
  const searchParams = useSearchParams();
  const isConnecting = searchParams.get('strava_connected') === 'true';

  const handleConnect = () => {
    window.location.href = getAuthUrl();
  };

  if (STRAVA_INTEGRATION_UNAVAILABLE) {
    return (
      <div className='flex justify-start'>
        <div className='text-xs text-gray-500 p-2'>
          Strava sync is temporarily unavailable. We&apos;ll let you know when
          it&apos;s back.
        </div>
      </div>
    );
  }

  if (connected === true) {
    return (
      <div className='flex justify-start'>
        <button
          className='btn btn-info flex gap-2 items-center cursor-default opacity-80 h-10'
          disabled
        >
          Strava Connected
        </button>
      </div>
    );
  }

  return (
    <div className='flex justify-start'>
      {connected === false && !isConnecting ? (
        <button
          className='hover:opacity-80 transition-opacity'
          onClick={handleConnect}
        >
          <ConnectWithStrava />
        </button>
      ) : (
        <div className='flex items-center gap-2 p-2'>
          <Loading size={14} />
          <span className='text-xs text-gray-500'>
            {isConnecting ? 'Connecting Strava...' : 'Checking...'}
          </span>
        </div>
      )}
    </div>
  );
};
